import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-customer-left-update-dialog',
  templateUrl: './customer-left-update-dialog.component.html',
  styleUrls: ['./customer-left-update-dialog.component.scss']
})
export class CustomerLeftUpdateDialogComponent implements OnInit {

  customerUpdateForm: FormGroup;
  disableDate: boolean;
  LoaderComponent: any;
  constructor(
    public dialogRef: MatDialogRef<CustomerLeftUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public service: WebRequestService,
  ) { }

  onNoClick() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.customerUpdateForm = this.fb.group({
      arrivalDate: new FormControl(this.data.arrivedOn, [Validators.required]),
      departureDate: new FormControl(this.data.departingOn, [Validators.required]),
      isLeftIndia: new FormControl(''),
      description: new FormControl('', [Validators.required])
    });
  }

  onChange(event){
    if(event.checked) {
      this.disableDate = true;
      this.customerUpdateForm.get('arrivalDate').clearValidators();
      this.customerUpdateForm.get('arrivalDate').updateValueAndValidity();
      this.customerUpdateForm.get('departureDate').clearValidators();
      this.customerUpdateForm.get('departureDate').updateValueAndValidity();
    } else {
      this.disableDate = false;
      this.customerUpdateForm.get('arrivalDate').setValidators([Validators.required]);
      this.customerUpdateForm.get('arrivalDate').updateValueAndValidity();
      this.customerUpdateForm.get('departureDate').setValidators([Validators.required]);
      this.customerUpdateForm.get('departureDate').updateValueAndValidity();
    }
  }

  _convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [month, day, year].join('/');
  }

  onSubmit() {
    const data = {
      isLeftIndia: this.customerUpdateForm.value.isLeftIndia === '' ? false : true,
      cust_Id: this.data.cust_ID,
      departureDescription: this.customerUpdateForm.value.description,
      arrivalDate: this._convertDate(this.customerUpdateForm.value.arrivalDate),
      departureDate: this._convertDate(this.customerUpdateForm.value.departureDate)
    }
    this.LoaderComponent = LoaderComponent;
    this.service.updateDepartedCustomerInfo(data).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.dialogRef.close(true);
      } else {
        this.LoaderComponent = '';
      }
    })

  }

}
